import React from "react";
import { motion } from "framer-motion";
import "../Styles/Testimonials.css";
import { FaMedal, FaStar, FaUser } from "react-icons/fa";
import IntlMessages from "../../../intl/IntlMessages";

const Team = () => {
  const testimonials = [
    {
      id: 1,
      content:
      <IntlMessages id="testimonials.pilot" />,
      author: "MBEZELE Lourdes Alexandra Patricia",
      role: <IntlMessages id="testimonials.marketingAgent" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 2,
      content: <IntlMessages id="testimonials.joinManagerText" />,
      author: "ABANDA ATEBA Grâce Fortune",
      role: <IntlMessages id="testimonials.joinManager" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 3,
      content: <IntlMessages id="testimonials.marketingDirectorText" />,
      author: "Mr Samy",
      role: <IntlMessages id="testimonials.marketingDirector" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 4,
      content:
        <IntlMessages id="testimonials.realEstateDirectorText" />,
      author: "MONKAM DONGMO Patrick",
      role: <IntlMessages id="testimonials.realEstateDirector" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 5,
      content: <IntlMessages id="testimonials.devOneText" />,
      author: "JEANNE NGOG TEDGA Brenda",
      role: <IntlMessages id="testimonials.devOne" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 6,
      content: <IntlMessages id="testimonials.consultingText" />,
      author: "BAKOBOG Albert Le Grand",
      role: <IntlMessages id="testimonials.consulting" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 7,
      content: <IntlMessages id="testimonials.devTwoText" />,
      author: "TAKUISSU NEKAM Martial",
      role: <IntlMessages id="testimonials.devTwoText" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 8,
      content:
        <IntlMessages id="testimonials.devGeneralDirectorText" />,
      author: "MAYEGA NGUIMBUS Alain Donatien",
      role: <IntlMessages id="testimonials.devGeneralDirector" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      company: "Estatia SCI",
      rating: 5,
    },
    {
      id: 9,
      content:
        <IntlMessages id="testimonials.devCollaboratorText" />,
      author: <IntlMessages id="testimonials.devCollaboratorTitle" />,
      picture: <FaUser color="#EEEEEE" size={56} />,
      role: <IntlMessages id="testimonials.devCollaborator" />,
      company: "Estatia SCI",
      rating: 5,
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="team-bg-pattern" />
      <div className="testimonials-container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2>
            <IntlMessages id="team.ourPrestigiousTeam" />
          </h2>
          <p>
            <IntlMessages id="team.qualifiedProfessionals" />
          </p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="quote-icon">
                <FaMedal />
              </div>
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <div className="bg-picture">{testimonial.picture}</div>
              <p className="testimonial-content">{testimonial.content}</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.role}</p>
                  <span>{testimonial.company}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
